import type { Listing } from 'shared/@types';

export function prefetchListingDetailImage(_listing: Listing) {
  // Web pages already get server-rendered detail data; native uses the platform implementation.
}
